import app from "../_app";

class PredictiveSearch extends HTMLElement {
    constructor() {
        super();

        this.input = this.querySelector('.js-searchbar-field');
        this.predictiveSearchResults = this.querySelector('#predictive-search');

        this.input.addEventListener('input', this.debounce((event) => {
            this.onChange(event);
        }, 300).bind(this));
    }

    onChange() {
        const searchTerm = this.input.value.trim();

        if (!searchTerm.length) {
            this.close();
            return;
        }

        this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
        fetch(`${Shopify.routes.root}search/suggest?q=${searchTerm}&section_id=predictive-search`)
            .then((response) => {
                if (!response.ok) {
                    var error = new Error(response.status);
                    this.close();
                    throw error;
                }

                return response.text();
            })
            .then((text) => {

                const results = new DOMParser().parseFromString(text, 'text/html').querySelector('.predictive-search').innerHTML;
                const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

                if (results !== '') {
                    this.predictiveSearchResults.innerHTML = resultsMarkup;
                } else {
                    this.predictiveSearchResults.innerHTML = '<div class="content pt-4 pb-2 fs-300 fw-300 text-center">' + app.translationHelper('search.no-results') + '"' + searchTerm + '"</div>';
                }
                this.open();

            })
            .catch((error) => {
                this.close();
                throw error;
            });
    }

    open() {
        this.predictiveSearchResults.style.display = 'block';
    }

    close() {
        this.predictiveSearchResults.style.display = 'none';
    }

    debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }
}

customElements.define('predictive-search', PredictiveSearch);
